module.exports = __webpack_public_path__ + "img/19_maska_vog-kvadrat.64461ed.svg";